import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { register, unregister } from './serviceWorkerRegistration';
// M4-R2: a report page opened with a one-time report token renders alone.
import { isReportRenderUrl } from './components/pages/LexiStar/Reports/reportSession';
import ReportRenderShell from './components/pages/LexiStar/Reports/ReportRenderShell';
import ErrorBoundary, { installChunkErrorReload } from './components/common/ErrorBoundary';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element in index.html');
const root = ReactDOM.createRoot(container);

if (isReportRenderUrl()) {
  // M4-R2 (m4-contracts §6): …/lexistar/reports/…?report_session=<token> — the
  // chrome-free report shell exchanges the token and prints the page; no app
  // shell, no /auth/me, no login redirect, no service worker.
  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <ReportRenderShell />
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  // A tab left open across a deploy asks for chunk files the new build no longer
  // has: reload once to pick up the new version (ST-00215, PLT-3). Not installed
  // for the report shell above: its one-time token cannot survive a reload.
  installChunkErrorReload();

  // ThemeProvider sits outermost: it has no auth dependency, and the auth screens
  // need the tokens too (even though they stay dark in both themes). The app-level
  // ErrorBoundary is the last line of defence; pages have their own (App.tsx,
  // TabHost.jsx), so a page error keeps the sidebar.
  root.render(
    <React.StrictMode>
      <ErrorBoundary fullScreen>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

  if (import.meta.env.PROD) {
    register();
  } else {
    unregister();
  }
  reportWebVitals();
}
